import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Itemcategory = (props) => {

    return (
        <div
            className="item-category"
            onClick={props.setCategory} >
            <div className="pic">
                <img src={props.image} />
            </div>
            <span>{props.title}</span>
        </div>
    );
}

export default Itemcategory;